import { render } from "./TrailerWithWarning.vue?vue&type=template&id=331c9157&scoped=true&ts=true"
import script from "./TrailerWithWarning.vue?vue&type=script&lang=ts"
export * from "./TrailerWithWarning.vue?vue&type=script&lang=ts"

import "./TrailerWithWarning.vue?vue&type=style&index=0&id=331c9157&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331c9157"]])

export default __exports__